import { render } from "./SelledTogetherProducts.vue?vue&type=template&id=4c612560"
import script from "./SelledTogetherProducts.vue?vue&type=script&lang=js"
export * from "./SelledTogetherProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__